import { Radio, RadioGroup } from '@odekoteam/doppio';

import { formatDateTo12Hour } from 'src/utils/date';
import {
  isQuoteExpired,
  ProviderQuote,
  quoteProviderLabel,
  quoteTotalLabel,
  sortQuotes,
  vehicleLabel,
} from 'src/utils/thirdPartyDelivery';

const expiryText = (quote: ProviderQuote, timeZone: string): string => {
  if (isQuoteExpired(quote)) return ' · expired';
  if (!quote.expiresAt) return '';
  return ` · until ${formatDateTo12Hour(new Date(quote.expiresAt), timeZone)}`;
};

// The provider's quotes, cheapest first, one selectable at a time. Each names
// the class it was priced for: a cargo van and a car are different prices.
export function QuoteList({
  quotes,
  selectedId,
  onSelect,
  timeZone,
}: {
  quotes: readonly ProviderQuote[];
  selectedId: string | undefined;
  onSelect: (id: string) => void;
  timeZone: string;
}): JSX.Element {
  return (
    <RadioGroup
      name="provider-quote"
      accessibilityLabel="Quotes"
      value={selectedId ?? ''}
      onChange={onSelect}
    >
      {sortQuotes(quotes).map((quote) => (
        <Radio key={quote.id} value={quote.id}>
          {`${quoteProviderLabel(quote)} · ${vehicleLabel(
            quote.vehicleType,
          )} · ${quoteTotalLabel(quote)}${expiryText(quote, timeZone)}`}
        </Radio>
      ))}
    </RadioGroup>
  );
}
